
/**
 * SEO utilities for social media and OpenGraph tags
 */

/**
 * Updates OpenGraph meta tags for social sharing
 */
export const updateOpenGraphTags = (
  title: string,
  description: string,
  ogImage: string,
  ogType: string,
  canonicalUrl?: string,
  language?: string
): void => {
  updateOpenGraphTag('og:title', title);
  updateOpenGraphTag('og:description', description);
  updateOpenGraphTag('og:image', ogImage);
  updateOpenGraphTag('og:type', ogType);
  
  if (canonicalUrl) {
    updateOpenGraphTag('og:url', canonicalUrl);
  }
  
  // Add locale OG tag based on language
  if (language) {
    updateOpenGraphTag('og:locale', language === 'de' ? 'de_CH' : 
                                 language === 'fr' ? 'fr_CH' : 
                                 language === 'it' ? 'it_CH' : 'en_CH');
  }
  
  // Update Twitter tags
  updateTwitterTag('twitter:title', title);
  updateTwitterTag('twitter:description', description);
  updateTwitterTag('twitter:image', ogImage);
  updateTwitterTag('twitter:card', 'summary_large_image');
};

/**
 * Helper function to update or create Open Graph meta tags
 */
export const updateOpenGraphTag = (property: string, content: string): void => {
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (tag) {
    tag.setAttribute('content', content);
  } else {
    tag = document.createElement('meta');
    tag.setAttribute('property', property);
    tag.setAttribute('content', content);
    document.head.appendChild(tag);
  }
};

/**
 * Helper function to update or create Twitter meta tags
 */
export const updateTwitterTag = (name: string, content: string): void => {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (tag) {
    tag.setAttribute('content', content);
  } else {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    tag.setAttribute('content', content);
    document.head.appendChild(tag);
  }
};
